import React, { useEffect } from 'react';
import { Card, Typography, Stack, Chip, useTheme } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { useDispatch, useSelector } from 'react-redux';
import { getAppointmentStatusSummaryRequest } from './../../store/appActions';

export default function AppointmentStatusPieChart() {
  const theme = useTheme();

  const dispatch = useDispatch();
  const data = useSelector((state) => state.app.appointmentstatussummary || []);

   useEffect(() => {
      dispatch(getAppointmentStatusSummaryRequest());
    }, [dispatch]);

  const STATUS_COLORS = {
    Completed: theme.palette.action.green,
    Pending: theme.palette.action.purpleDark,
    Cancelled: theme.palette.action.red,
  };

  const pieColors = data.map(
    (entry) => STATUS_COLORS[entry.name]
  );

  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: theme.shadows[1],
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Typography
        variant="h6"
        fontWeight={theme.typography.h6.fontWeight}
        fontFamily={theme.typography.fontFamily}
        color={theme.palette.text.primary}
        mb={2}
      >
        Appointment Status
      </Typography>

      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            outerRadius={80}
            innerRadius={50}
            paddingAngle={5}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={pieColors[index]} />
            ))}
          </Pie>
          <Tooltip
            wrapperStyle={{
              fontFamily: theme.typography.fontFamily,
              fontSize: 14,
              backgroundColor: theme.palette.background.paper,
              borderColor: theme.palette.grey.mediumGray,
              borderWidth: 1,
              borderStyle: 'solid',
              borderRadius: 4,
              color: theme.palette.text.primary,
            }}
            contentStyle={{ padding: '6px 10px' }}
          />
        </PieChart>
      </ResponsiveContainer>

      <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
        {data.map((item, index) => (
          <Chip
            key={index}
            label={`${item.name}: ${item.value}`}
            sx={{
              backgroundColor: pieColors[index],
              color: theme.palette.common.white,
              fontWeight: 500,
              fontFamily: theme.typography.fontFamily,
            }}
          />
        ))}
      </Stack>
    </Card>
  );
}
